export default "__VITE_ASSET__Cp1xP7uU__"